<div *ngIf="{data: expanded$ | async} as expanded">
  <mat-radio-group [formControl]="radioForm.get('radio')">
    <div class="nivel-logro-group">
      <ng-container *ngFor="let criterioNivel of nivel.criterios">
        <div *ngIf="criterioNivel.id === criterioEvaluacionId" class="nivel-logro-cont">
          <mat-radio-button hidden #radio [value]="criterioNivel.id">
          </mat-radio-button>
          <app-autoevaluacion-criterio-button [criterioNombre]="criterioNivel.nombre" [criterioId]="criterioNivel.id"
            [radio]="radio" [radioForm]="radioForm" [label]="criterioNivel.escala.nickName"
            [criterioEvaluacionId]="criterioEvaluacionId" [autoevaluacion]="autoevaluacion" [imagenProfesor]=""
            [imagenAlumno]="autoevaluacion.imageUrl" [label]="criterioNivel.escala.nickName"
            [criterioEscala]="criterioNivel.escala.nombre" [expanded]="expanded.data">
          </app-autoevaluacion-criterio-button>
        </div>
      </ng-container>
      <div *ngIf="expanded.data" class="nivel-logro__expandir">
        <button mat-icon-button color="primary" (click)="expand()">
          <mat-icon>add_circle_outline</mat-icon>
        </button>

        <label role="button" (click)="expand()">Ver todo</label>

      </div>
    </div>
  </mat-radio-group>
  <!--  <div *ngIf="expanded.data">
    <button mat-icon-button color="primary" (click)="expand()"><mat-icon>add_circle_outline</mat-icon></button>
  </div> -->
</div>
